import { useCookies } from "react-cookie";

export const COOKIE_NAME = "app_PMA_cookies"; // Single cookie for storing all user data

export const useAppCookies = () => {
    const [cookies, setCookie, removeCookie] = useCookies([COOKIE_NAME]);

    // Get all stored cookie data as an object
    const getUser = () => {

        if (!cookies[COOKIE_NAME]) return null;
        try {
            const userData = cookies[COOKIE_NAME];
            return userData; // Ensures proper structure
        } catch (error) {
            console.error("Error parsing cookie data:", error);
            return null;
        }
    };

    // Set entire User object in cookie
    const setUser = (user) => {

        const data = JSON.stringify(user);

        // 8 hours = 8 / 24 = 0.333... days
        setCookie(COOKIE_NAME, data, {
            path: '/',
            expires: new Date(Date.now() + 8 * 60 * 60 * 1000), // Expires in 8 hours
        });
    };


    // Remove all stored user data
    const clearUser = () => {
        removeCookie(COOKIE_NAME, { path: "/" });
    };



    return {
        setUser,
        getUser,
        clearUser,
    };
};


// cookiesUtils.ts
export function clearUserCookies() {
    document.cookie = 'user=; Max-Age=0; path=/;'; // or however you're clearing it
}
